import {Component, Input, OnChanges} from '@angular/core';
import {TimingStatus} from 'src/app/services/api/api';

@Component({
  selector: 'sb-comp-commercial-count',
  templateUrl: './sb-commercial-count.component.html',
  styleUrls: ['./sb-commercial-count.component.scss'],
  standalone: false,
})
export class SbCommercialCountComponent implements OnChanges {
  _commercialCount: any | null;
  commercialCountSum: number;
  timingStatusCount: Map<TimingStatus, number>;
  @Input() currentTimingFilter: TimingStatus[];

  @Input() set commercialCount(val: any | null) {
    this._commercialCount = val;
  }

  get commercialCount(): any | null {
    return this._commercialCount;
  }

  constructor() {
    this.currentTimingFilter = null;
    this._commercialCount = null;
    this.commercialCountSum = 0;
  }

  ngOnChanges(): void {
    if (this.commercialCount != null && !(this.commercialCount instanceof Map)) {
      this.commercialCount = this.getTimings(this.currentTimingFilter, this.commercialCount);
      this.commercialCountSum = this.calcSum(this.commercialCount);
    }
  }

  getTimings(currentTimingFilter: TimingStatus[], timingStatusObj: any): Map<TimingStatus, number> {
    const timingStatusCount = new Map<TimingStatus, number>();
    for (const timingStatus in TimingStatus) {
      if (currentTimingFilter != null && currentTimingFilter.length > 0) {
        for (const currentTimingStatus of currentTimingFilter) {
          if (timingStatusObj && Object.prototype.hasOwnProperty.call(timingStatusObj, TimingStatus[currentTimingStatus])) {
            timingStatusCount.set(TimingStatus[currentTimingStatus], timingStatusObj[currentTimingStatus]);
          }
        }
      } else {
        if (timingStatusObj && Object.prototype.hasOwnProperty.call(timingStatusObj, TimingStatus[timingStatus])) {
          timingStatusCount.set(TimingStatus[timingStatus], timingStatusObj[timingStatus]);
        }
      }
    }
    return timingStatusCount;
  }

  calcSum(commercialCount: Map<TimingStatus, number>): number {
    let num = 0;
    if (commercialCount) {
      for (const [key, val] of commercialCount) {
        num = num + val;
      }
    }
    return num;
  }
}
